export default __webpack_public_path__ + "845a0cc4e6e6f7c764d81b3341e87e39.svg";